import { styled } from "@mui/material/styles";
import FormLabelMui from "@mui/material/FormLabel";
import { Body2 } from "../../BSPBody2";

export const FormLabel = styled(FormLabelMui)`
  ${Body2}
  color: ${({ theme }) => theme.kinetic.v2.palette.rgb.grayTextLighter};
` as unknown as typeof FormLabelMui;
